import { HeaderStyle } from '../../models/enum';
import { PrintOptions } from './print';
import { PageSizes } from './print';
import { pageOptions } from './print';
import { PageOption } from './print';

export interface IPrintConfiguration {
    backgroundColor: string;
    beginDateFormat?: string;
    endDateFormat?: string;
    fileNameTemplate?: string;
    headerStyle?: HeaderStyle;
    isAutoStore?: boolean;
    isCompactHeader?: boolean;
    isHiddenHeader?: boolean;
    isHidingBorder: boolean;
    isUseNewPrintSystem?: boolean;
    printOptions: PrintOptions;
}

export interface IPrintOptionsService {
    getOptions(): PageOption[];
    getFormats(): any[];
}

export class PrintOptionsService implements IPrintOptionsService {
    static serviceId = 'printOptionsService';

    private _formats = PageSizes;
    private _options = pageOptions;

    getFormats() {
        return this._formats;
    }

    getOptions() {
        return this._options;
    }

}